import React, { useEffect, useRef, useState } from 'react';

import BaseScreen from "../BaseScreen";
import { AuthNavProps } from "../navigation/auth/AuthParamList";
import NavBar from "../../components/NavBar";
import {
    Image,
    Keyboard,
    Pressable,
    StyleSheet,
    TouchableOpacity,
    View,
} from "react-native";
import { white } from "../../assets/style/colors";
import { BottomButtonView } from "../../components/BottomButtonView";
import { checkAcApi, checkVerifyCode, forgotPsd, qryQuestion, resetPasswdByVerifyCode, sendVerifyCode } from "../../net/service";
import { showToast } from "../../components/Toast";
import { showDialog } from "../../components/CommonDialog";
import { hideLoading, showLoading } from "../../components/Loading";
import {
    Str_CodeAlreadySend, Str_CodeSendFail, Str_Confirm,
    Str_ConfirmPsd,
    Str_Err1013,
    Str_Err1014,
    Str_Err1015,
    Str_Err400,
    Str_Err500,
    Str_ForgotPsd,
    Str_InputAcc,
    Str_InputAnswer,
    Str_InputCode,
    Str_InputNewPsd,
    Str_InputPhone,
    Str_PhoneFormatErr,
    Str_PhoneNotNull, Str_PsdFormatErr,
    Str_PsdInconsistent, Str_PsdLengthErr1,
    Str_PsdLengthErr2, Str_PsdNotNull, Str_ReSend, Str_SendCode,
    Str_ThePsd,
    Str_InputEmail,
    Str_EmailNotNull,
    Str_QueryFail,
    Str_ProblemNotNull,
    Str_AccFormatErr,
    Str_NoSpacesAllowed,
    Str_UnbindEmailError
} from "../../language/string_res";
import { CryptEngine } from "../../utils/CryptEngine";
import { getLanguage } from "../../language/i18n";
import { CommonInput } from "./CommonInput";
import { accValidate, isNumeric, validatePassword } from './register';
import { BehavioralVerifyModal } from './BehavioralVerifyModal';


export function getCodeMsg(code: number) {
    if (code === 500) {
        return Str_Err500
    }
    if (code === 1013) {
        return Str_Err1013
    }
    if (code === 1014) {
        return Str_Err1014
    }
    if (code === 1015) {
        return Str_Err1015
    }
    if (code === 400) {
        return Str_Err400
    }
    return undefined
}

export const ForgotPassword = ({ navigation, route }: AuthNavProps<'ForgotPassword'>) => {
    const type = route.params.type;
    const vcode = route.params.vcode;
    const defAccount = route.params.defAccount ?? ""

    const [psd, setPsd] = useState('')
    const [againPsd, setAgainPsd] = useState('')
    const [code, setCode] = useState('')
    const [problem, setProblem] = useState('')
    const [sendText, setSendText] = useState(Str_SendCode)

    const [answer, setAnswer] = useState('')
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordAgain, setShowPasswordAgain] = useState(false);
    const [running, setRunning] = useState(false);
    const eventTagRef = useRef("")
    let timer: any;
    let endTime: number = 0;
    const [isVerifyModalShow, setIsVerifyModalShow] = useState(false)
    const captchaToken = useRef<string>("")

    const lang = getLanguage()
    useEffect(() => {
        if (type === 1) {
            fetchSecurityQuestion()
        }
    }, [])

    /**
     * 验证邮箱验证吗
     */
    const verifyCode = () => {
        showLoading('')
        const body = {
            send_type: '15',
            vcode: vcode,
            code: code,
            lang: lang,
            eventTag: eventTagRef.current,
        }
        checkVerifyCode(body).then((res) => {
            if (res.code === 0 && res.data && res.data.otp_token) {
                const token = res.data?.otp_token ?? ""
                resetPasswdByCode(token)
            } else {
                const msg = res.msg || getCodeMsg(res.code) || ''
                showToast(msg)
                hideLoading()
            }
        })
    }

    /**
     * 通过邮箱找回
     */
    const resetPasswdByCode = (token: string) => {
        const body = {
            lang: lang,
            passwd: getCryptPsd(),
            vcode: vcode,
            otp_token: token,
            eventTag: eventTagRef.current,
        }
        resetPasswdByVerifyCode(body).then((r) => {
            handleResponse(r)
        }).finally(() => {
            hideLoading()
        })
    }
    
    /**
     * 通过密保问题找回
     */
    function submitSecurity(isShowLoading: boolean) {
        if (!isShowLoading) {
            showLoading('')
        }

        const body = {
            account: defAccount,
            security_info: { security_problem: problem, security_answer: answer },
            passwd: getCryptPsd(),
            vcode: vcode,
            lang: lang
        }
        forgotPsd(body).then((res) => {
            handleResponse(res)
        }).finally(() => {
            hideLoading()
        })
    }

    const handleResponse = (res: any) => {
        if (res.code === 0) {
            showDialog({
                message: Str_ThePsd,
                onConfirm: () => {
                    navigation.goBack()
                }
            })
        } else {
            showToast(res.msg || '')
        }
    }

    const getCryptPsd = () => CryptEngine.md5(psd.trim()).toLowerCase()//CryptEngine.handleEncode(psd, cryptKey, cid)

    /**
     * 发送邮箱验证吗
     * @returns 
     */
    function handleEmailCode() {
        if (running) {
            return;
        }

        setIsVerifyModalShow(true)
    }
    /**
     * 发送短信验证码
     * @returns 
     */
    function handlePhoneCode() {
        if (running) {
            return;
        }
        setIsVerifyModalShow(true)
    }

    const onSendCodeBehavioralVerifySuccess = async (isSuccess: boolean, token: string) => {
        // 验证未通过
        if (isSuccess !== true) {
            return
        }

        // 记录验证码token
        captchaToken.current = token
        // 检查账号并且发送验证码
        checkAccountAndSendCode(defAccount, "15")
    }

    // 检查账号并且发送验证码
    function checkAccountAndSendCode(acc: string, send_type: string) {
        // 先校验账号,获取EventTag
        checkAcApi({ account: acc, vcode: vcode, lang: lang }).then((res) => {
            if (res.code === 0 && res.data?.boundEmail === true) {
                // 存在
                const eventTag = res.data.eventTag
                eventTagRef.current = eventTag
                startTime()
                // 发送手机验证码
                sendVerifyCode({ send_type: send_type, eventTag: eventTag, lang: lang, vcode: vcode, captchaToken: captchaToken.current }).then(res => {
                    if (res.code === 0) {
                        showToast(Str_CodeAlreadySend)
                    } else {
                        showToast(res.msg || Str_CodeSendFail)
                        reset()
                    }
                })
            } else {
                reset()
                if (res.data?.boundEmail !== true) {
                    showDialog({
                        message: Str_UnbindEmailError,
                        onConfirm: () => { }
                    })
                } else {
                    showToast(res.msg || Str_CodeSendFail)
                }
            }
        }).catch((res) => {
            showToast(res.msg || Str_CodeSendFail)
            reset()
        })
    }

    function startTime() {
        endTime = Date.now() + 60 * 1000;
        setRunning(true);
        updateRemain();
    }
    function updateRemain() {
        cancelAnimationFrame(timer);
        const tick = () => {
            const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
            // setRemainTime(left);
            // running ? `${remainTime}s` : Str_ReSend
            setSendText(`${left}s`)
            if (left > 0) {
                timer = requestAnimationFrame(tick);
            } else {
                reset();
            }
        };

        tick();
    }
    function reset() {
        cancelAnimationFrame(timer);
        // setRemainTime(0);
        setRunning(false);
        setSendText(Str_ReSend)
    }

    async function QryQuestion(): Promise<boolean> {
        return qryQuestion(defAccount, vcode, lang).then(r => {
            const p = r.data?.security_info?.security_problem
            if (p && p.length > 0) {
                setProblem(p)
                return true
            } else {
                setProblem('')
                showToast(r?.msg || Str_QueryFail)
                return false
            }

        }).catch(e => {
            showToast(Str_QueryFail)
            return false
        })
    }

    const handleSubmit = async () => {
        let isShowLoading = false
        if (type === 1) {
            if (defAccount.trim().length === 0) {
                showToast(Str_InputAcc)
                return undefined
            }
            if (problem.length === 0) {
                if (!accValidate(defAccount)) {
                    showToast(Str_AccFormatErr)
                    return undefined
                }
                showLoading()
                isShowLoading = true
                const r = await QryQuestion()
                if (!r) {
                    hideLoading()
                    return undefined
                }
            }
            if (problem.trim().length === 0) {
                if (isShowLoading) {
                    isShowLoading = false
                    hideLoading()
                }
                showToast(Str_ProblemNotNull)
                return undefined
            }
            if (answer.trim().length === 0) {
                if (isShowLoading) {
                    isShowLoading = false
                    hideLoading()
                }
                showToast(Str_InputAnswer)
                return undefined
            }
        } else if (type === 2) {
            if (code.trim().length === 0) {
                showToast(Str_InputCode)
                return undefined
            }
        } else if (type === 3) {
            if (code.trim().length === 0) {
                showToast(Str_InputCode)
                return undefined
            }
        }
        if (psd.trim().length === 0) {
            showToast(Str_PsdNotNull)
            return undefined
        }
        if (psd.trim().length < 8) {
            showToast(Str_PsdLengthErr1)
            return undefined
        }
        if (psd.trim().length > 32) {
            showToast(Str_PsdLengthErr2)
            return undefined
        }
        if (!validatePassword(psd)) {
            showToast(Str_PsdFormatErr)
            return
        }
        if (psd.trim() !== againPsd.trim()) {
            showToast(Str_PsdInconsistent)
            return
        }
        switch (type) {
            case 1:
                submitSecurity(isShowLoading)
                break
            case 2:
            case 3:
                verifyCode()
                break
        }
    }

    const fetchSecurityQuestion = () => {
        if (type === 1 && defAccount && defAccount.length > 0) {
            if (!accValidate(defAccount)) {
                showToast(Str_AccFormatErr)
                return
            }
            QryQuestion().then()
        }
    }

    return (<BaseScreen styles={{ backgroundColor: white }}>
        <NavBar showBack={true} title={Str_ForgotPsd} />
        <Pressable
            onPress={Keyboard.dismiss}>
            <View style={{ flex: 1, paddingHorizontal: 16 }}>
                <CommonInput
                    editable={false}
                    imgStyle={styles.accImage}
                    style={{ marginTop: 30 }}
                    source={require('../../assets/image/icon_account.png')}
                    placeholder={Str_InputAcc}
                    text={defAccount}
                    showClean={false}
                    onChangeText={() => { }} />

                {type === 1 && <View style={{ marginTop: 1 }}>
                    <CommonInput
                        imgStyle={styles.accImage}
                        style={{ marginTop: 12 }}
                        source={require('../../assets/image/icon_psd.png')}
                        placeholder={''}
                        text={problem}
                        editable={false}
                        // sendText={Str_ClickQuery}
                        // sendCode={QryQuestion}
                        onChangeText={setProblem} />

                    <CommonInput
                        imgStyle={styles.accImage}
                        style={{ marginTop: 12 }}
                        source={require('../../assets/image/icon_psd.png')}
                        placeholder={Str_InputAnswer}
                        text={answer}
                        showClean={true}
                        onChangeText={setAnswer} />

                </View>}
                {type === 2 &&
                    <View style={{ marginTop: 1 }}>
                        <CommonInput
                            imgStyle={styles.accImage}
                            source={require('../../assets/image/icon_psd.png')}
                            placeholder={Str_InputCode}
                            style={{ marginTop: 12 }}
                            sendText={sendText}//running ? `${remainTime}s` : Str_ReSend
                            sendCode={handlePhoneCode}
                            text={code}
                            keyboardType="numeric"
                            onChangeText={setCode} />
                    </View>}
                {type === 3 &&
                    <View style={{ marginTop: 1 }}>
                        <CommonInput
                            imgStyle={styles.accImage}
                            source={require('../../assets/image/icon_psd.png')}
                            placeholder={Str_InputCode}
                            style={{ marginTop: 12 }}
                            sendText={sendText}
                            sendCode={handleEmailCode}
                            text={code}
                            keyboardType="numeric"
                            onChangeText={setCode} />
                    </View>
                }

                <CommonInput
                    imgStyle={styles.accImage}
                    style={{ marginTop: 32 }}
                    source={require('../../assets/image/icon_psd.png')}
                    placeholder={Str_InputNewPsd}
                    text={psd}

                    secureTextEntry={!showPassword}
                    rightIcon={
                        <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
                            <Image
                                source={
                                    showPassword
                                        ? require("../../assets/image/icon_eye.png")
                                        : require("../../assets/image/icon_close_eye.png")
                                }
                                style={{ width: 20, height: 20, tintColor: '#999' }} // 可加 tintColor 控色
                                resizeMode="contain"
                            />
                        </TouchableOpacity>
                    }
                    onChangeText={setPsd} />

                <CommonInput
                    imgStyle={styles.accImage}
                    style={{ marginTop: 12 }}
                    source={require('../../assets/image/icon_psd.png')}
                    placeholder={Str_ConfirmPsd}
                    text={againPsd}
                    secureTextEntry={!showPasswordAgain}
                    rightIcon={
                        <TouchableOpacity onPress={() => setShowPasswordAgain(!showPasswordAgain)}>
                            <Image
                                source={
                                    showPasswordAgain
                                        ? require("../../assets/image/icon_eye.png")
                                        : require("../../assets/image/icon_close_eye.png")
                                }
                                style={{ width: 20, height: 20, tintColor: '#999' }} // 可加 tintColor 控色
                                resizeMode="contain"
                            />
                        </TouchableOpacity>
                    }
                    onChangeText={setAgainPsd} />

                <BottomButtonView
                    style={{ marginTop: 32 }}
                    contentStyle={{ paddingHorizontal: 0 }}
                    text={Str_Confirm}
                    onClick={handleSubmit} />
            </View>
        </Pressable>

        <BehavioralVerifyModal
            visible={isVerifyModalShow}
            onResult={(isSuccess, token) => {
                setIsVerifyModalShow(false)
                onSendCodeBehavioralVerifySuccess(isSuccess, token)
            }}
        />
    </BaseScreen>)
}

const styles = StyleSheet.create({
    accImage: {
        width: 17,
        height: 17,
        objectFit: 'contain'
    },

})